import { render, staticRenderFns } from "./upgradeRecord.vue?vue&type=template&id=6dad348a&scoped=true&"
import script from "./upgradeRecord.vue?vue&type=script&lang=js&"
export * from "./upgradeRecord.vue?vue&type=script&lang=js&"
import style0 from "./upgradeRecord.vue?vue&type=style&index=0&id=6dad348a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dad348a",
  null
  
)

export default component.exports